import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export interface MyCompany {
  companyId: string
  name: string
}

interface State {
  companies: MyCompany[]
  activeCompanyId: string | null
  loading: boolean
}

export function useMyCompanies(): State {
  const [companies, setCompanies] = useState<MyCompany[]>([])
  const [activeCompanyId, setActiveCompanyId] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) { if (!cancelled) setLoading(false); return }

      const [{ data: memberships }, { data: profile }] = await Promise.all([
        supabase
          .from('company_memberships')
          .select('company_id, companies(name)')
          .eq('user_id', user.id),
        supabase
          .from('profiles')
          .select('company_id')
          .eq('id', user.id)
          .single(),
      ])

      if (cancelled) return

      const list: MyCompany[] = (memberships ?? []).map(m => ({
        companyId: m.company_id as string,
        name: (m.companies as unknown as { name: string } | null)?.name ?? 'Empresa',
      }))
      setCompanies(list)
      setActiveCompanyId((profile?.company_id as string | undefined) ?? null)
      setLoading(false)
    })()
    return () => { cancelled = true }
  }, [])

  return { companies, activeCompanyId, loading }
}
